/** sharing screen strings (EN source of truth + VI); spread into the main dictionaries */

export const sharingEn = {
  'sharing.lockedWhileEditing': 'Save or cancel your edit to change these settings.',
  // Document properties panel
  'sharing.info': 'Document info',
  'sharing.category': 'Category',
  'sharing.categoryPlaceholder': 'e.g. Engineering, Product',
  'sharing.categorySaveFailed': 'Could not save the category: {message}',
  'sharing.accessSaved': 'Access updated',
  'sharing.accessSaveFailed': 'Could not change who can see it: {message}',
  'sharing.created': 'Created',
  'sharing.updated': 'Updated',
  'sharing.author': 'Author',
  'sharing.copyFailed': 'Could not copy the link',
  'sharing.copyPublicUrl': 'Copy public link',
  'sharing.openPublicUrl': 'Open public page',

  'sharing.publish.title': 'Publishing',
  'sharing.publish.published': 'Published. Anyone can read this page at its public link, without signing in.',
  'sharing.publish.notPublished': 'Not published. Publishing makes this page readable by anyone at /pub/{slug}.',
  'sharing.publish.button': 'Publish',
  'sharing.publish.dialogTitle': 'Publish this page',
  'sharing.publish.dialogBody': 'Anyone with the public link can read the page without signing in: {url}',
  'sharing.publish.description': 'Description',
  'sharing.publish.descriptionHint': 'Shown with the published page. Say what it covers.',
  'sharing.publish.descriptionRequired': 'Add a description before publishing.',
  'sharing.publish.submit': 'Publish page',
  'sharing.publish.publishing': 'Publishing…',
  'sharing.publish.done': 'Page published',
  'sharing.publish.failed': 'Could not publish: {message}',
  'sharing.publish.unpublish': 'Unpublish',
  'sharing.publish.unpublishConfirm': 'Unpublish this page? Its public link stops working, and it goes back to who could see it before it was published.',
  'sharing.publish.unpublished': 'Page unpublished',
  'sharing.publish.changeAccessConfirm': 'This page is published. Changing who can see it unpublishes it, and its public link stops working. Continue?',

  'sharing.links.title': 'Share links',
  'sharing.links.hint': 'Anyone with a share link can read this page without an account, even when it is not published.',
  'sharing.links.privateHint': 'Only you can see this page, so new share links are turned off. Change who can see it to share a link.',
  'sharing.links.stillOpen': 'Existing share links still open this page to anyone who has them ({count}). Revoke them to stop sharing.',
  'sharing.links.create': 'Create share link',
  'sharing.links.creating': 'Creating…',
  'sharing.links.created': 'Share link created',
  'sharing.links.createFailed': 'Could not create a share link: {message}',
  'sharing.links.empty': 'No share links yet.',
  'sharing.links.loadError': 'Could not load share links.',
  'sharing.links.copy': 'Copy share link',
  'sharing.links.revoke': 'Revoke share link',
  'sharing.links.revokeConfirm': 'Revoke this share link? Anyone using it loses access.',
  'sharing.links.revoked': 'Share link revoked',
  'sharing.links.revokeFailed': 'Could not revoke the share link: {message}',
  'sharing.links.expires': 'Expires {date}',
  'sharing.links.expired': 'Expired {date}',
  'sharing.links.noExpiry': 'Does not expire',

  // Public views (/share/:token, /pub/:slug)
  'sharing.public.shared': 'Shared document',
  'sharing.public.published': 'Published document',
  'sharing.public.sharedError': 'This share link is invalid or has expired.',
  'sharing.public.publishedError': 'This document does not exist or is not published.',
  'sharing.public.home': 'Go to AgentWiki',

  // Hosted sites (/sites)
  'sites.title': 'Hosted sites',
  'sites.subtitle': 'Upload an HTML file or a ZIP with its assets and get a link you can share.',
  'sites.count': '{count} sites',
  'sites.countOne': '1 site',
  'sites.files': '{count} files',
  'sites.filesOne': '1 file',
  'sites.search': 'Search sites',
  'sites.loadError': 'Could not load hosted sites.',
  'sites.empty': 'No hosted sites yet.',
  'sites.emptyHint': 'Upload an HTML file or ZIP archive to get a shareable link.',
  'sites.noMatch': 'No sites match the current filters.',
  'sites.copied': 'Link copied',
  'sites.copyFailed': 'Could not copy the link',

  'sites.upload': 'Upload site',
  'sites.upload.title': 'Upload a site',
  'sites.upload.description': 'Description',
  'sites.upload.descriptionPlaceholder': 'e.g. Q1 revenue dashboard',
  'sites.upload.descriptionHint': 'Required. Say what the site shows, up to {max} characters.',
  'sites.upload.file': 'Site file (.html or .zip)',
  'sites.upload.fileHint': 'HTML up to 10 MB, or a ZIP up to 50 MB that contains an index.html.',
  'sites.upload.autoSummary': 'Generate an AI summary',
  'sites.upload.submit': 'Upload',
  'sites.upload.uploading': 'Uploading…',
  'sites.upload.done': 'Uploaded {name}',
  'sites.upload.failed': 'Upload failed: {message}',
  'sites.upload.needFile': 'Choose an .html or .zip file.',
  'sites.upload.needDescription': 'Add a description.',

  'sites.filter.status': 'Filter by status',
  'sites.filter.allStatuses': 'All statuses',
  'sites.filter.type': 'Filter by site type',
  'sites.filter.allTypes': 'All types',
  'sites.filter.date': 'Filter by upload date',
  'sites.filter.allTime': 'All time',
  'sites.filter.last7': 'Last 7 days',
  'sites.filter.last30': 'Last 30 days',
  'sites.filter.last90': 'Last 90 days',
  'sites.filter.reset': 'Reset filters',
  'sites.status.ready': 'Ready',
  'sites.status.processing': 'Processing',
  'sites.status.failed': 'Failed',
  'sites.type.html': 'HTML',
  'sites.type.zip': 'ZIP',
  'sites.view.label': 'Layout',
  'sites.view.list': 'List view',
  'sites.view.grid': 'Grid view',

  'sites.action.copy': 'Copy link',
  'sites.action.copyNamed': 'Copy link to {name}',
  'sites.action.open': 'Open in a new tab',
  'sites.action.openNamed': 'Open {name} in a new tab',
  'sites.action.preview': 'Preview',
  'sites.action.previewNamed': 'Preview {name}',
  'sites.action.delete': 'Delete',
  'sites.action.deleteNamed': 'Delete {name}',
  'sites.details.show': 'Details',
  'sites.details.hide': 'Hide details',
  'sites.details.showNamed': 'Show details for {name}',
  'sites.details.hideNamed': 'Hide details for {name}',

  'sites.description.label': 'Description',
  'sites.description.none': 'No description.',
  'sites.description.edit': 'Edit',
  'sites.description.add': 'Add description',
  'sites.description.saved': 'Description saved',
  'sites.description.saveFailed': 'Could not update the description: {message}',

  'sites.summary.label': 'AI summary',
  'sites.summary.generate': 'Generate AI summary',
  'sites.summary.generating': 'Generating summary…',
  'sites.summary.regenerate': 'Regenerate',
  'sites.summary.regenerating': 'Regenerating…',
  'sites.summary.showMore': 'Show more',
  'sites.summary.showLess': 'Show less',
  'sites.summary.failed': 'Could not generate a summary: {message}',

  'sites.versions.title': 'Versions',
  'sites.versions.listLabel': 'Versions of {name}',
  'sites.versions.version': 'v{version}',
  'sites.versions.live': 'Live',
  'sites.versions.empty': 'No version history.',
  'sites.versions.loadError': 'Could not load versions.',
  'sites.versions.rollback': 'Roll back',
  'sites.versions.rollbackNamed': 'Roll back to version {version}',
  'sites.versions.rollbackTitle': 'Roll back site',
  'sites.versions.rollbackBody': 'Serve version {version} of "{name}" again? Visitors see it right away. Other versions stay in the history.',
  'sites.versions.rollingBack': 'Rolling back…',
  'sites.versions.rolledBack': 'Now serving version {version}',
  'sites.versions.rollbackFailed': 'Could not roll back: {message}',
  'sites.versions.conflict': 'the site changed in the meantime. The version list was refreshed; try again.',

  'sites.preview.title': 'Preview: {name}',
  'sites.preview.open': 'Open in a new tab',

  'sites.delete.title': 'Delete site',
  'sites.delete.body': 'Delete "{name}" and all its files? This cannot be undone.',
  'sites.delete.confirm': 'Delete site',
  'sites.delete.deleting': 'Deleting…',
  'sites.delete.done': 'Deleted {name}',
  'sites.delete.failed': 'Could not delete the site: {message}',
} satisfies Record<string, string>

export const sharingVi: Record<keyof typeof sharingEn, string> = {
  'sharing.lockedWhileEditing': 'Lưu hoặc hủy bản đang sửa để đổi các thiết lập này.',
  'sharing.info': 'Thông tin tài liệu',
  'sharing.category': 'Danh mục',
  'sharing.categoryPlaceholder': 'Ví dụ: Kỹ thuật, Sản phẩm',
  'sharing.categorySaveFailed': 'Không lưu được danh mục: {message}',
  'sharing.accessSaved': 'Đã cập nhật quyền xem',
  'sharing.accessSaveFailed': 'Không đổi được quyền xem: {message}',
  'sharing.created': 'Tạo lúc',
  'sharing.updated': 'Cập nhật',
  'sharing.author': 'Tác giả',
  'sharing.copyFailed': 'Không sao chép được liên kết',
  'sharing.copyPublicUrl': 'Sao chép liên kết công khai',
  'sharing.openPublicUrl': 'Mở trang công khai',

  'sharing.publish.title': 'Xuất bản',
  'sharing.publish.published': 'Đã xuất bản. Ai cũng đọc được trang này qua liên kết công khai mà không cần đăng nhập.',
  'sharing.publish.notPublished': 'Chưa xuất bản. Khi xuất bản, ai cũng đọc được trang này tại /pub/{slug}.',
  'sharing.publish.button': 'Xuất bản',
  'sharing.publish.dialogTitle': 'Xuất bản trang này',
  'sharing.publish.dialogBody': 'Ai có liên kết công khai đều đọc được trang mà không cần đăng nhập: {url}',
  'sharing.publish.description': 'Mô tả',
  'sharing.publish.descriptionHint': 'Hiển thị cùng trang đã xuất bản. Hãy nói rõ trang nói về điều gì.',
  'sharing.publish.descriptionRequired': 'Hãy thêm mô tả trước khi xuất bản.',
  'sharing.publish.submit': 'Xuất bản trang',
  'sharing.publish.publishing': 'Đang xuất bản…',
  'sharing.publish.done': 'Đã xuất bản trang',
  'sharing.publish.failed': 'Không xuất bản được: {message}',
  'sharing.publish.unpublish': 'Hủy xuất bản',
  'sharing.publish.unpublishConfirm': 'Hủy xuất bản trang này? Liên kết công khai sẽ ngừng hoạt động và quyền xem trở lại như trước khi xuất bản.',
  'sharing.publish.unpublished': 'Đã hủy xuất bản trang',
  'sharing.publish.changeAccessConfirm': 'Trang này đang được xuất bản. Đổi quyền xem sẽ hủy xuất bản và liên kết công khai ngừng hoạt động. Tiếp tục?',

  'sharing.links.title': 'Liên kết chia sẻ',
  'sharing.links.hint': 'Ai có liên kết chia sẻ đều đọc được trang này mà không cần tài khoản, kể cả khi trang chưa xuất bản.',
  'sharing.links.privateHint': 'Chỉ mình bạn xem được trang này nên không tạo được liên kết chia sẻ mới. Hãy đổi quyền xem để chia sẻ.',
  'sharing.links.stillOpen': 'Các liên kết chia sẻ hiện có vẫn mở được trang này cho bất kỳ ai có liên kết ({count}). Hãy thu hồi chúng để ngừng chia sẻ.',
  'sharing.links.create': 'Tạo liên kết chia sẻ',
  'sharing.links.creating': 'Đang tạo…',
  'sharing.links.created': 'Đã tạo liên kết chia sẻ',
  'sharing.links.createFailed': 'Không tạo được liên kết chia sẻ: {message}',
  'sharing.links.empty': 'Chưa có liên kết chia sẻ nào.',
  'sharing.links.loadError': 'Không tải được danh sách liên kết chia sẻ.',
  'sharing.links.copy': 'Sao chép liên kết chia sẻ',
  'sharing.links.revoke': 'Thu hồi liên kết chia sẻ',
  'sharing.links.revokeConfirm': 'Thu hồi liên kết chia sẻ này? Người đang dùng nó sẽ mất quyền truy cập.',
  'sharing.links.revoked': 'Đã thu hồi liên kết chia sẻ',
  'sharing.links.revokeFailed': 'Không thu hồi được liên kết chia sẻ: {message}',
  'sharing.links.expires': 'Hết hạn {date}',
  'sharing.links.expired': 'Đã hết hạn {date}',
  'sharing.links.noExpiry': 'Không hết hạn',

  'sharing.public.shared': 'Tài liệu được chia sẻ',
  'sharing.public.published': 'Tài liệu đã xuất bản',
  'sharing.public.sharedError': 'Liên kết chia sẻ này không hợp lệ hoặc đã hết hạn.',
  'sharing.public.publishedError': 'Tài liệu này không tồn tại hoặc chưa được xuất bản.',
  'sharing.public.home': 'Đến AgentWiki',

  'sites.title': 'Trang đã host',
  'sites.subtitle': 'Tải lên một tệp HTML hoặc tệp ZIP kèm tài nguyên để có liên kết chia sẻ.',
  'sites.count': '{count} trang',
  'sites.countOne': '1 trang',
  'sites.files': '{count} tệp',
  'sites.filesOne': '1 tệp',
  'sites.search': 'Tìm trang',
  'sites.loadError': 'Không tải được danh sách trang đã host.',
  'sites.empty': 'Chưa có trang nào được host.',
  'sites.emptyHint': 'Tải lên tệp HTML hoặc tệp ZIP để có liên kết chia sẻ.',
  'sites.noMatch': 'Không có trang nào khớp bộ lọc hiện tại.',
  'sites.copied': 'Đã sao chép liên kết',
  'sites.copyFailed': 'Không sao chép được liên kết',

  'sites.upload': 'Tải trang lên',
  'sites.upload.title': 'Tải lên một trang',
  'sites.upload.description': 'Mô tả',
  'sites.upload.descriptionPlaceholder': 'Ví dụ: Bảng doanh thu quý 1',
  'sites.upload.descriptionHint': 'Bắt buộc. Cho biết trang hiển thị gì, tối đa {max} ký tự.',
  'sites.upload.file': 'Tệp trang (.html hoặc .zip)',
  'sites.upload.fileHint': 'HTML tối đa 10 MB, hoặc ZIP tối đa 50 MB có chứa index.html.',
  'sites.upload.autoSummary': 'Tạo tóm tắt bằng AI',
  'sites.upload.submit': 'Tải lên',
  'sites.upload.uploading': 'Đang tải lên…',
  'sites.upload.done': 'Đã tải lên {name}',
  'sites.upload.failed': 'Tải lên thất bại: {message}',
  'sites.upload.needFile': 'Hãy chọn một tệp .html hoặc .zip.',
  'sites.upload.needDescription': 'Hãy thêm mô tả.',

  'sites.filter.status': 'Lọc theo trạng thái',
  'sites.filter.allStatuses': 'Mọi trạng thái',
  'sites.filter.type': 'Lọc theo loại trang',
  'sites.filter.allTypes': 'Mọi loại',
  'sites.filter.date': 'Lọc theo ngày tải lên',
  'sites.filter.allTime': 'Mọi thời điểm',
  'sites.filter.last7': '7 ngày qua',
  'sites.filter.last30': '30 ngày qua',
  'sites.filter.last90': '90 ngày qua',
  'sites.filter.reset': 'Xóa bộ lọc',
  'sites.status.ready': 'Sẵn sàng',
  'sites.status.processing': 'Đang xử lý',
  'sites.status.failed': 'Lỗi',
  'sites.type.html': 'HTML',
  'sites.type.zip': 'ZIP',
  'sites.view.label': 'Bố cục',
  'sites.view.list': 'Dạng danh sách',
  'sites.view.grid': 'Dạng lưới',

  'sites.action.copy': 'Sao chép liên kết',
  'sites.action.copyNamed': 'Sao chép liên kết của {name}',
  'sites.action.open': 'Mở trong thẻ mới',
  'sites.action.openNamed': 'Mở {name} trong thẻ mới',
  'sites.action.preview': 'Xem trước',
  'sites.action.previewNamed': 'Xem trước {name}',
  'sites.action.delete': 'Xóa',
  'sites.action.deleteNamed': 'Xóa {name}',
  'sites.details.show': 'Chi tiết',
  'sites.details.hide': 'Ẩn chi tiết',
  'sites.details.showNamed': 'Xem chi tiết {name}',
  'sites.details.hideNamed': 'Ẩn chi tiết {name}',

  'sites.description.label': 'Mô tả',
  'sites.description.none': 'Chưa có mô tả.',
  'sites.description.edit': 'Sửa',
  'sites.description.add': 'Thêm mô tả',
  'sites.description.saved': 'Đã lưu mô tả',
  'sites.description.saveFailed': 'Không cập nhật được mô tả: {message}',

  'sites.summary.label': 'Tóm tắt bằng AI',
  'sites.summary.generate': 'Tạo tóm tắt bằng AI',
  'sites.summary.generating': 'Đang tạo tóm tắt…',
  'sites.summary.regenerate': 'Tạo lại',
  'sites.summary.regenerating': 'Đang tạo lại…',
  'sites.summary.showMore': 'Xem thêm',
  'sites.summary.showLess': 'Thu gọn',
  'sites.summary.failed': 'Không tạo được tóm tắt: {message}',

  'sites.versions.title': 'Phiên bản',
  'sites.versions.listLabel': 'Các phiên bản của {name}',
  'sites.versions.version': 'v{version}',
  'sites.versions.live': 'Đang chạy',
  'sites.versions.empty': 'Chưa có lịch sử phiên bản.',
  'sites.versions.loadError': 'Không tải được danh sách phiên bản.',
  'sites.versions.rollback': 'Khôi phục',
  'sites.versions.rollbackNamed': 'Khôi phục về phiên bản {version}',
  'sites.versions.rollbackTitle': 'Khôi phục trang',
  'sites.versions.rollbackBody': 'Phục vụ lại phiên bản {version} của "{name}"? Người xem thấy ngay. Các phiên bản khác vẫn được giữ trong lịch sử.',
  'sites.versions.rollingBack': 'Đang khôi phục…',
  'sites.versions.rolledBack': 'Đang phục vụ phiên bản {version}',
  'sites.versions.rollbackFailed': 'Không khôi phục được: {message}',
  'sites.versions.conflict': 'trang vừa bị thay đổi. Danh sách phiên bản đã được làm mới, hãy thử lại.',

  'sites.preview.title': 'Xem trước: {name}',
  'sites.preview.open': 'Mở trong thẻ mới',

  'sites.delete.title': 'Xóa trang',
  'sites.delete.body': 'Xóa "{name}" cùng toàn bộ tệp? Không thể hoàn tác.',
  'sites.delete.confirm': 'Xóa trang',
  'sites.delete.deleting': 'Đang xóa…',
  'sites.delete.done': 'Đã xóa {name}',
  'sites.delete.failed': 'Không xóa được trang: {message}',
}
